import React from 'react';

export interface ICheckoutState {
  [key: string]: string | number | boolean;
}

export enum Environments {
  development = 'development',
  staging = 'staging',
  sandbox = 'sandbox',
  production = 'production',
  local = 'local',
}

export interface IErrors {
  [key: string]: string;
}

export enum PaymentOptions {
  cit = 'cit',
  mit = 'mit',
}

export enum SourceOptions {
  empty = '',
  ecommerce = 'ecommerce',
  installment = 'installment',
  mailorder = 'mailorder',
  recurring = 'recurring',
  retail = 'retail',
  telephone = 'telephone',
  applepay = 'applepay',
  androidpay = 'androidpay',
  vterminal = 'vterminal',
  terminal = 'terminal',
}

export enum FlowsOptions {
  iframe = 'iframe',
  terminal = 'terminal',
  steps = 'steps',
  withoutOrderId = 'withoutOrderId',
}

// export type PaymentOptions = 'default' | 'mit';

let environment: Environments = (process.env.REACT_APP_ENVIRONMENT as Environments) || Environments.sandbox;
let loading: boolean = false;
let errors: IErrors = {};
let paymentErrors: any = null;
let redirect: string = 'modal';
let iframeSize: string = '02';
// let paymentOptions: PaymentOptions = PaymentOptions.default;
let paymentOptions: string = PaymentOptions.cit;
let sourceOptions: string = SourceOptions.empty;
let flow: string = FlowsOptions.iframe;

const CheckoutContext = React.createContext({
  environment,
  setEnvironment(environment: Environments) {
    this.environment = environment;
  },
  loading,
  setLoading(loading: boolean) {
    this.loading = loading;
  },
  errors,
  setErrors(errors: IErrors) {
    this.errors = errors;
  },
  paymentErrors,
  setPaymentErrors(paymentErrors: any) {
    this.paymentErrors = paymentErrors;
  },
  redirect,
  setRedirect(redirect: string) {
    this.redirect = redirect;
  },
  iframeSize,
  setIframeSize(iframeSize: string) {
    this.iframeSize = iframeSize;
  },
  paymentOptions,
  setPaymentOptions(option: PaymentOptions) {
    this.paymentOptions = option;
  },
  sourceOptions,
  setSourceOptions(option: SourceOptions) {
    this.sourceOptions = option;
  },
  flow,
  setFlow(option: FlowsOptions) {
    this.flow = option;
  },
});

export { CheckoutContext };
